import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppInitializerService {
  constructor(private translate: TranslateService) {}

  initialize(): Observable<any> {
    this.translate.setDefaultLang('en');
    this.translate.addLangs(['en', 'ar']);
    const savedLanguage = localStorage.getItem('selected-language') || 'en';
    return this.translate.use(savedLanguage).pipe(
      catchError(() => of(null)),
      map(() => {
        const dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.dir = dir;
        document.documentElement.lang = savedLanguage;
        return null;
      })
    );
  }
}

export function initializeApp(appInitializer: AppInitializerService) {
  return () => appInitializer.initialize();
}
